module.exports = __webpack_public_path__ + "img/124.a309f736.jpg";